import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.783 2.087a1.043 1.043 0 1 1 0-2.087h4.174C15.533 0 16 .467 16 1.043v4.174a1.043 1.043 0 0 1-2.087 0V3.563L10.825 6.65a1.043 1.043 0 1 1-1.476-1.476l3.088-3.088zM6.65 9.349a1.043 1.043 0 0 1 0 1.476l-3.088 3.088h1.654a1.043 1.043 0 0 1 0 2.087H1.043A1.043 1.043 0 0 1 0 14.957v-4.174a1.043 1.043 0 1 1 2.087 0v1.654L5.175 9.35a1.043 1.043 0 0 1 1.476 0m-.39-8.306c0 .577-.467 1.044-1.044 1.044H3.563L6.65 5.175a1.043 1.043 0 0 1-1.476 1.476L2.087 3.563v1.654a1.043 1.043 0 0 1-2.087 0V1.043C0 .467.467 0 1.043 0h4.174c.577 0 1.044.467 1.044 1.043m3.088 9.782a1.043 1.043 0 1 1 1.476-1.476l3.088 3.088v-1.654a1.043 1.043 0 0 1 2.087 0v4.174c0 .576-.467 1.043-1.043 1.043h-4.174a1.043 1.043 0 0 1 0-2.087h1.654z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }